// extracted by mini-css-extract-plugin
export default {"active":"launchers_financial_active__toiJa"};